module.exports = __webpack_public_path__ + "img/factory-swiper-2.f9936e5c.png";